import './index_mWeb.css';
import { View, FlatListWrapper, LanguageBtn } from '../../../component';
import Constants from '../../../constants';
import { s } from '../../../utilities/scaling_utils';
import FlatList from 'flatlist-react';
import YNAnswerViewMWeb from '../../component/yn_answer_view/index_mWeb';
import { FantasyYesNoRule, InsightInfo, YesNoVideo } from '../../component';
import Button from '@mui/material/Button/Button';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';

const MyAnswerTab = ({
  answerList,
  editMode,
  onChange2x,
  onChangeMyAnswer,
  language,
  onPressInsight,
  insightInfoModal,
  onPressClose,
  insight,
  ruleModal,
  onPressDismissRule,
  yesNoVideoModal,
  onPressDismissYNVideo,
  onPressOpenRule,
  onPressOpenYNVideo,
  onChangeEditMode
}: any) => {
  const renderAnsItem = (item: any) => {
    const { sequence = 0 } = item;
    return (
      <YNAnswerViewMWeb
        key={item.id}
        item={item}
        qNo={sequence}
        editMode={editMode}
        onChange2x={() => onChange2x(sequence - 1)}
        onChangeMyAnswer={() => onChangeMyAnswer(sequence - 1)}
        language={language}
        onPressInsight={() => onPressInsight(sequence - 1)}
      />
    );
  };

  return (
    <ScreenBackgroundWrapper>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          padding: '15px 10px 15px 10px',
          backgroundColor: '#192330'
        }}>
        <div
          style={{
            display: 'table',
            textAlign: 'right'
          }}>
          <LanguageBtn />
        </div>
        <Button
          style={{
            backgroundColor: 'transparent',
            color: '#fff'
          }}
          onClick={onPressOpenRule}
          className={'MyAnswerTab__button_mWeb'}>
          {'Points System'}
        </Button>
        <Button
          style={{
            backgroundColor: 'transparent',
            color: '#fff'
          }}
          onClick={onPressOpenYNVideo}
          className={'MyAnswerTab__button_mWeb'}>
          {'How to Play?'}
        </Button>
      </View>
      <View
        style={{
          position: 'relative',
          paddingLeft: s(20),
          paddingRight: s(20),
          height: '100%'
        }}>
        <FlatListWrapper
          style={{
            paddingBottom: '150px'
          }}>
          <FlatList
            list={answerList}
            renderItem={renderAnsItem}
            // renderWhenEmpty={renderWhenEmpty}
          />
        </FlatListWrapper>
        <View
          style={{
            position: 'absolute',
            zIndex: 10,
            right: 0,
            bottom: '15%',
            display: 'flex',
            alignItems: 'center',
            width: '100%'
          }}
          onPress={onChangeEditMode}>
          {editMode ? (
            <button className="yesNo__answerTab__save__btn__mWeb">Save</button>
          ) : (
            <Constants.Svgs.YesNo_EditBtn width={100} height={100} />
          )}
        </View>
      </View>
      <InsightInfo
        visible={insightInfoModal}
        onPressClose={onPressClose}
        insight={insight}
        language={language}
      />
      <FantasyYesNoRule
        visible={ruleModal}
        onPressDismiss={onPressDismissRule}
        language={language}
      />
      <YesNoVideo visible={yesNoVideoModal} onPressClose={onPressDismissYNVideo} />{' '}
    </ScreenBackgroundWrapper>
  );
};
export default MyAnswerTab;
